import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetGamePoster } from "../ScrollableListView";
import { Link } from "react-router-dom";
import { AsyncImage } from "loadable-image";
import { useParams } from "react-router-dom";
import i18n from "i18n";
import { IoPlayCircleOutline } from "react-icons/io5";
import { Translation } from "react-i18next";
import Emitter from "_actions/emitter";
const MatGameBox = (props) => {
  const containerRef = useRef(null);
  const [H, setH] = useState(null);
  const { item, index, isLive } = props;
  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }

  const resizeBox = () => {
    if (containerRef && containerRef.current) {
      const w = containerRef.current?.clientWidth;
      const prgmaticName =
        document.querySelector(".prgmaticName")?.offsetHeight;

      containerRef.current.style.height = `${w + prgmaticName}px`;

      setH(`${w + prgmaticName}px`);
    }
  };
  useEffect(() => {
    window.addEventListener("DOMContentLoaded", resizeBox);
    window.addEventListener("resize", resizeBox);
  }, []);

  return (
    <Translation>
      {(t) => (
        <>
          <div
            ref={containerRef}
            key={item.gameID + item.gameIdNumeric}
            className="GameBox h-[143px] md:h-[220px]  bg-primary-500 md:bg-secondary-500 group/item cursor-pointer md:border md:border-primary-500"
            onLoad={() => resizeBox()}
            style={{
              height: H ? H : undefined,
            }}
          >
            <div className="games-img">
              <AsyncImage
                className="h-full w-full rounded-t-[2.5vw] md:rounded-t-md rounded-b-[2.5vw]"
                id={"ppg-poster" + item.gameID}
                src={GetGamePoster("pragmatic", item)}
                alt={item.gameName}
                loader={
                  <div className="skeleton w-full h-full bg-secondary-500">
                    <img
                      src={require("../../../assets/img/gamebox1.png")}
                    ></img>
                  </div>
                }
                error={
                  <div className="bg-secondary-500 max-h-[136px] md:max-h-[220px] flex justify-center items-center">
                    <img
                      className="max-h-[136px] md:max-h-[220px]"
                      src={require("../../../assets/img/gamebox2.png")}
                    ></img>
                  </div>
                }
              />
            </div>
            <div className="game-hover group-hover/item:before:opacity-80"></div>
            {isLive && (
              <div
                style={{ position: "absolute" }}
                id={"ppg" + item.gameID}
                className="top-0 w-full  flex flex-row justify-between"
              //className="games-img "
              >
                <span
                  id={"ppg-limitbet" + item.gameID}
                  className="game-live-limitbet opacity-[0]  bg-primary-500/80"
                ></span>
                <span
                  id={"ppg-account" + item.gameID}
                  className="game-live-limitbet-account opacity-[0] bg-primary-500/80"
                ></span>

              </div>
            )}
            {isLive == true ? (
              props.loggedIn ? (
                <Link

                  to={`/matgame/${item.uniq_provider}/${item.id}`}
                  className="game-btns   flex-col px-6"
                >
                  <IoPlayCircleOutline className="text-primary-500 w-14 h-14" />
                </Link>
              ) : (
                <div
                  onClick={() => {
                    Emitter.emit("LOGIN_MODAL", true);
                  }}
                  className="game-btns   flex-col px-6"
                >
                  <IoPlayCircleOutline className="text-primary-500 w-14 h-14" />
                </div>
              )) : (
              <div className="game-btns   flex-col   h-full">
                <div className="game-btn-item game-btn-title flex flex-row   justify-start md:justify-center items-center text-center text-[#fff] text-sm px-2 py-0">
                  {item.name}
                </div>
                <div className="game-btn-item game-btn-provider flex flex-row   justify-start md:justify-center items-center text-[#b2b2b2] text-xs px-2 pb-1">
                  {item.provider_title}
                </div>
                {
                  props.loggedIn ? (
                    <Link

                      to={`/matgame/${item.uniq_provider}/${item.id}`}
                      className="game-btn-item game-btn-play flex flex-row m-1  justify-start md:justify-center items-center text-xs border border-white rounded-md px-6 mt-2 py-1"
                    >
                      {t("BUTTON_PLAY")}
                    </Link>
                  )
                    :
                    (
                      <div
                        onClick={() => {
                          Emitter.emit("LOGIN_MODAL", true);
                        }}
                        className="game-btn-item game-btn-play flex flex-row m-1  justify-start md:justify-center items-center text-xs border border-white rounded-md px-6 mt-2 py-1"
                      >
                        {t("BUTTON_PLAY")}
                      </div>
                    )
                }

              </div>
            )}

            {
              /*
              <span className="prgmaticName name text-white after:bg-secondary-500 group-hover/item:after:bg-primary-500 group-hover/item:after:opacity-[0.9] group-hover/item:text-secondary-500">
              {item.gameName}
            </span>
              */
            }
          </div>
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games } = game;
  return {
    loggedIn,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MatGameBox);
